module.exports = __webpack_public_path__ + "img/xbox.68ce5519.png";